module.exports = __webpack_public_path__ + "static/media/img3.f123488d.jpg";